export const CHARTBEAT_RECOMMENDATION_CONFIG = {
  endpoint:
    "https://recommendations.chartbeat.net/publishing/recommendations/v2/device",
  host: "beritaharian.sg",
  path: "beritaharian.sg/",
  limit: "20",
  excludeSections: "miscellaneous,podcasts,videos", // Excluding search results and other non-article sections to improve recommendation quality
  apiUrl: "https://api.chartbeat.com/live/toppages/v3/",
  articlesCount: 20,
  cacheTtlSeconds: 60 * 60, // 1 hour
  cacheKey: "CHARTBEAT_POPULAR_ARTICLES",
} as const;
